<template>
  <div class="text-center select-none">
    <div class="text-gray-400 text-xs">Московский театр</div>
    <div class="text-white text-xl leading-5">«На досках»</div>
  </div>
</template>